import React, { Component, Fragment, createRef } from 'react';
import { connect } from 'react-redux';
import { Button, Card, CardBody, Col, Container, Input, InputGroup, Label, /*InputGroupAddon, InputGroupText,*/ Row } from 'reactstrap';

import { confirmRegister,toggleData ,find,validateRegister } from '../../store/actions/userActions';
import { findCompany} from '../../store/actions/companyActions';
//import GenericCropter from '../Plugins/Dropzone/GenericCropter';
import { Preloader } from '../Plugins/';
import { nameValidateRegex } from '../../store/actions/UtilsOperation';
import Notification from '../../handlers/Notification';
import { axios } from '../../handlers/RequestHandler';
import { URLsmall } from '../../config';
import PayoutAccounts from './PayoutAccounts';
class Confirmation extends Component {
	constructor(props){
		super(props);

		this.imageRef = createRef();

		this.state={
			step: 1,
			account: {
				password: "",
				password_confirm: ""
			},
			validPassword: false,
			validConfirmPassword: false,
			validatePaymentForm: false,
			accept: false,
			vehicles: [],
			services: [],
			loadingVehicles: true,
			loadingServices: true
		}

		if(this.props.match.params.id && this.props.match.params.token){
			this.props.find(this.props.match.params.id,this.props.match.params.token).then(() => {
				if(this.props.account && this.props.account.company_id){
					this.props.findCompany(this.props.account.company_id).then(() => {
		            	if(this.props.account && this.props.account.client){
							this.props.validateRegister(this.props.account)
						}else{
							if(this.props.account.provider){
								axios.get(`${URLsmall}vehicle-types?limit=0`).then((res) => {
									this.setState(prevState => ({
										vehicles: res.data,
										loadingVehicles: false,
										account: {
											...prevState.account,
											vehicle_type: Number(res.data[0].id)
										}
									}))
								});

								axios.get(`${URLsmall}service-types?limit=0`).then((res) => {
									this.setState(prevState => ({
										services: res.data,
										loadingServices: false,
										account: {
											...prevState.account,
											service_type: Number(res.data[0].id)
										}
									}))
								});
							}
							this.setState(prevState => ({
								account: {
									...prevState.account,
									...this.props.account
								}
							}));
						}
					}).catch( (err) => {
						console.log("error en validar cliente",err)
					});
				}else{
					this.props.history.push(`/invalidate/${this.props.match.params.id }/${this.props.match.params.token}`)
				}
	        }).catch( (err) => {
	        	console.log("error",err)
			});
		}
	}
	onChange = ({ name, value }) => {

		const { account } = this.state;

		let validPassword = this.state.validPassword;
		let validConfirmPassword = this.state.validConfirmPassword;
		let updatedAccount = { ...account, [name]: value };

		if (name === "password"){
			if(value.length > 0 && value.length < 5){
				validPassword = false;
			}else{
				validPassword = true;
			}

			if(updatedAccount.password_confirm !== "" && value !== updatedAccount.password_confirm){
				validConfirmPassword = false;
			}else{
				validConfirmPassword = true;
			}
		}

		if(name === "password_confirm"){
			if(updatedAccount.password.length !== 0 && updatedAccount.password !== value){
				validConfirmPassword = false;
			}else{
				validConfirmPassword = true;
			}
		}

		if(name === "vehicle_type" || name === "service_type"){
			updatedAccount = { ...account, [name]: Number(value) };
		}

		this.setState({
		  account: updatedAccount,
		  validPassword,
		  validConfirmPassword,
		});
    }

	isFormValid = () => {
		const { account } = this.state;
		const isNumber = (value) => !isNaN(value) && typeof value === 'number';

		return account.brand
			&& account.model
			&& account.color
			&& account.plate
			&& account.year
			&& isNumber(account.service_type)
			&& isNumber(account.vehicle_type);
	};

	storeAccount = () => {
		const { account } = this.state;

		let validname = nameValidateRegex(account.name);
		if(!validname){
			Notification.show({
				type: "warning",
				title:this.props.json_lang.custom_errors.user_registration_failed,
				msg: 'Nombre con caracteres invalidos'
			});
		}else if((account.provider && account.is_deliverer) && !this.isFormValid()){
			Notification.show({
				type: "warning",
				title:this.props.json_lang.custom_errors.user_registration_failed,
				msg: 'Complete todos los campos por favor'
			});
		}else{
			this.props.confirmRegister(account)
		}

	}

	handleStoreAccount = () => {
		const { step, account } = this.state;
		if(account.provider && step === 1){
			if(account.is_deliverer){
				this.setState({
					step: 2
				});
			} else {
				this.setState({
					step: 3
				});
			}
		}else{
			this.storeAccount();
		}
    }

	handleDisabledFirstButton = () => {
		const { account, validPassword, validConfirmPassword, accept } = this.state;
		if(account.provider){
			return !(validPassword && validConfirmPassword && accept);
		}else{
			return !(validPassword && validConfirmPassword);
		}
	}

	render(){

		const { companyLogo, json_lang, dropzoneActive } = this.props;
		const {
			step,
			account,
			validPassword,
			validConfirmPassword,
			services,
			vehicles,
			accept,
			validatePaymentForm,
			loadingServices,
			loadingVehicles
		} = this.state;

		const invalidPasswordText = "La contraseña debe ser mayor a 5 dígitos";
		const invalidConfirmPasswordText = "Las contraseñas deben coincidir";

		return <div className="app flex-row align-items-center custom_bg" >
			{
				account && (account.provider || account.admin)?
					<Container>
						<Row className="justify-content-center">
							<Col md="5">
								<Card className="p-4">
									<CardBody>
										<img
											style={{display:'block',margin:'0 auto',maxWidth: '100%',height: '90px'}}
											ref={ this.imageRef }
											src={ companyLogo || '/assets/img/logo-default-180x64.svg' }
											onError={ ()=>this.imageRef.src = '/assets/img/logo-default-180x64.svg' }
											alt={  "Company Logo" }
										/>
										{
											step === 1 && (
												<Fragment>
													<h2 className="text-center mb-4"><b>Bienvenido, crea tu contraseña</b></h2>
													<div className={ dropzoneActive ? `off-hidden` : undefined}>
														<InputGroup className="mb-3" style={{height:'55px'}}>
															<Input
																id="name"
																type="text"
																name="name"
																placeholder={json_lang.common.name}
																value={ account.name || '' }
																onChange={ (e) => this.onChange(e.target) }/>
														</InputGroup>

														<InputGroup className="mb-3" style={{height:'55px'}}>
															<Input
																type="text"
																name="phone"
																placeholder={json_lang.common.phone}
																value={ account.phone || '' }
																onChange={ (e) => this.onChange(e.target) }/>
														</InputGroup>

														<InputGroup className="mb-3" style={{height:'55px'}}>
															<Input
																type="email"
																name="email"
																placeholder={json_lang.common.email}
																value={ account.email || '' }
																onChange={ (e) => this.onChange(e.target) }/>
														</InputGroup>

														<InputGroup className="mb-3 d-flex flex-column w-100">
															<Input
																type="password"
																name="password"
																className="w-100"
																style={{height:'55px'}}
																placeholder={json_lang.confirmation.password}
																value={ account.password || '' }
																onChange={ (e) => this.onChange(e.target) }/>
															{
																(!validPassword && account.password !== "") && (
																	<span className="text-danger d-inline-block">
																		{invalidPasswordText}
																	</span>
																)
															}
														</InputGroup>

														<InputGroup className="mb-3 d-flex flex-column w-100">
															<Input
																type="password"
																name="password_confirm"
																className="w-100"
																style={{height:'55px'}}
																placeholder={json_lang.confirmation.confirm_password}
																value={ account.password_confirm || '' }
																onChange={ (e) => this.onChange(e.target) }
																/>
															{
																(!validConfirmPassword && account.password_confirm !== "" ) && (
																	<span className="text-danger">
																		{invalidConfirmPasswordText}
																	</span>
																)
															}
														</InputGroup>
															{
																account.provider && (
																	<InputGroup className="mb-3">
																		<input
																			type="checkbox"
																			className="mr-2"
																			onChange={() => this.setState({ accept: !accept })}
																			checked={accept}
																		/>
																		Acepto los <a className="ml-1" href='https://rideryconductores.com/terminos-y-condiciones/' target="_blank">términos y condiciones</a>
																	</InputGroup>
																)
															}

														<Button
															color="primary btn-block"
															className="px-4"
															disabled = { this.handleDisabledFirstButton()  }
															style={{height: '55px',fontWeight: 'bold'}}
															onClick={ () => this.handleStoreAccount() }
														>
															{
																account.provider
																? json_lang.common.continue
																: json_lang.common.save
															}
														</Button>
													</div>
												</Fragment>
											)
										}
										{
											step === 2 && (
												<Fragment>
														<h2 className="text-center mb-4">
															<b>Completa los datos de tu vehículo</b>
														</h2>

														<Label className="text-muted">
															Tipo de servicio
														</Label>
														<select
															className="form-control w-100 mb-2"
															style={{ height: "50px" }}
															name="service_type"
															disabled={loadingServices || services.length === 0}
															onChange={(e) => this.onChange(e.target)}
															value={loadingServices ? "loading" : (account.service_type || "not_found")}
														>
															{
																loadingServices ?
																	<option value={"loading"} disabled>Cargando...</option>
																:
																	services && services.length !== 0 ?
																		services.map((service, index) => (
																			<option key={index} name="service_type" value={Number(service.id)}>{service.name}</option>
																		))
																	:
																	<option value={"not_found"} disabled>No hay servicios disponibles</option>
															}
														</select>

														<Label className="text-muted">
															Tipo de vehículo
														</Label>
														<select
															className="form-control w-100 mb-2"
															style={{ height: "50px" }}
															name="vehicle_type"
															disabled={loadingVehicles || vehicles.length === 0}
															onChange={(e) => this.onChange(e.target)}
															value={ loadingVehicles ? "loading" : (account.vehicle_type || "not_found")}
														>
															{
																loadingVehicles ?
																	<option value={"loading"} disabled>Cargando...</option>
																:
																	vehicles && vehicles.length !== 0 ?
																		vehicles.map((vehicle, index) => (
																			<option key={index} name="vehicle_type" value={Number(vehicle.id)}>{vehicle.name}</option>
																		))
																	:
																	<option value={"not_found"} disabled>No hay vehículos disponibles</option>
															}
														</select>

														<Label className="text-muted mt-2">
															Datos de vehículo
														</Label>

														<InputGroup className="mb-3" style={{height:'55px'}}>
															<Input
																type="text"
																name="brand"
																placeholder={"Marca"}
																value={ account.brand || '' }
																onChange={ (e) => this.onChange(e.target) }/>
														</InputGroup>

														<InputGroup className="mb-3" style={{height:'55px'}}>
															<Input
																type="text"
																name="model"
																placeholder={"Modelo"}
																value={ account.model || '' }
																onChange={ (e) => this.onChange(e.target) }/>
														</InputGroup>

														<InputGroup className="mb-3" style={{height:'55px'}}>
															<Input
																type="text"
																name="color"
																placeholder={"Color"}
																value={ account.color || '' }
																onChange={ (e) => this.onChange(e.target) }/>
														</InputGroup>

														<InputGroup className="mb-3" style={{height:'55px'}}>
															<Input
																type="text"
																name="plate"
																placeholder={"Placa"}
																value={ account.plate || '' }
																onChange={ (e) => this.onChange(e.target) }/>
														</InputGroup>

														<InputGroup className="mb-3" style={{height:'55px'}}>
															<Input
																type="number"
																name="year"
																placeholder={"Año"}
																value={ account.year || '' }
																onChange={ (e) => this.onChange(e.target) }/>
														</InputGroup>

														<div className="d-flex flex-row justify-content-between">
															<Button
																color="ghost"
																className="w-50 mr-2"
																style={{height: '55px',fontWeight: 'bold'}}
																onClick={() => this.setState({ step: 1 })}
															>
																Volver
															</Button>
															<Button
																color="primary"
																className="w-50 ml-2"
																disabled = {!this.isFormValid()}
																style={{height: '55px',fontWeight: 'bold'}}
																onClick={ () => this.setState({ step: 3 }) }
															>
																{json_lang.common.continue}
															</Button>
														</div>
												</Fragment>
											)
										}
										{
											step === 3 && (
												<Fragment>
													<h2 className="text-center mb-4">
														<b>Completa tus datos de pago</b>
													</h2>
													<PayoutAccounts
														key={"payout_accounts"}
														validatePaymentForm={(validate) =>  this.setState({ validatePaymentForm: validate })}
														appendPayoutAccount={(payoutData) => this.setState(prevState => ({
															account: {
																...prevState.account,
																payout_accounts: payoutData
															}
														}))}
													/>
													<div className="d-flex flex-row justify-content-between">
														<Button
															color="ghost"
															className="w-50 mr-2"
															style={{height: '55px',fontWeight: 'bold'}}
															onClick={() => this.setState({ step: account.is_deliverer ? 2 : 1 })}
														>
															Volver
														</Button>
														<Button
															color="primary"
															className="w-50 ml-2"
															disabled = { !validatePaymentForm }
															style={{height: '55px',fontWeight: 'bold'}}
															onClick={ () => this.storeAccount() }
														>
															{json_lang.common.save}
														</Button>
													</div>
												</Fragment>
											)
										}
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
				:null
			}
			<Preloader />
		</div>
	}
}

const mapStateToProps = (state) => {
	return {
		errors: state.errors,
		account:state.account,
		company:state.company,
		json_lang: state.json_lang,
		dropzoneActive:state.dropzoneActive,
		dropzoneFiles:state.dropzoneFiles,
		companyLogo: state.company && state.company.styles_json && state.company.styles_json.styles && state.company.styles_json.styles.company_logo
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		find:(id,token) => dispatch(find(id,token)),
		confirmRegister: (user) => dispatch(confirmRegister(user)),
		toggleData: (data) => dispatch(toggleData(data)),
		findCompany: (id) => dispatch(findCompany(id)),
		validateRegister: (data) => dispatch(validateRegister(data)),
		nameValidateRegex: (data) => dispatch(nameValidateRegex(data)),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Confirmation);



// WEBPACK FOOTER //
// ./src/views/Register/Confirmation.jsx